// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"126":"0c5a8771","171":"e9060710","453":"7e513c49"}[chunkId] + ".chunk.js";
};